import * as Yup from 'yup'
import {useState} from 'react'
import {useFormik,} from 'formik'
import useAuth from '../../../hooks/useAuth'
import {login} from '../../../services/authService'

type InitialValues = {
  username: string;
  password: string;
  remember?: boolean;
  afterSubmit?: string;
};

const LoginSchema = Yup.object().shape({
  username: Yup.string().email('El nombre de usuario debe ser valido').required('Se requiere un nombre de usuario'),
  password: Yup.string().required('Se requiere una contraseña')
});

function useLoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const context = useAuth();
  const formik = useFormik<InitialValues>({
    initialValues: {
        username: '',
        password: '',
      },
    validationSchema: LoginSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm })  => {
      try{
        const { accessToken, user }:any = await login(values.username,values.password);
        context.login(user, accessToken)
      }
      catch(error:any){
        // console.log(error.response.data.message)
        console.log(error);
        resetForm();
        //Falta agregar useRef
        setErrors({ afterSubmit: error.message });
      }
    },
})

function onClickShowPassword(){
  setShowPassword((prev) => !prev)
}

return {
  formik,
  showPassword,
  onClickShowPassword
};
   
}

export default useLoginForm
